export default __webpack_public_path__ + "static/media/File No. 10.04185819.pdf";